// @flow
import type { State } from 'app/common/redux/reducers/types';

export const getBoardsDeleting = (state: State) => state.boards.deleting;
export const getBoardsContent = (state: State) => state.boards.content;
